module.exports = __webpack_public_path__ + "img/prenota_smartbook.358eb81e.png";